module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof43"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The Table of Ranks also regulated promotions within the Imperial Retinue (Imperial Suite). In 1711, Peter the Great established the positions ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dolzhnost")]), _vm._v(") "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flügel")]), _vm._v(" adjutant and general adjutant. These positions enabled officers attached to the Commanders-in-Chief and the Emperor to carry out specific missions. From 1722 to 1731, the position of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flügel")]), _vm._v(" adjutant to the general field marshal was assigned to the XI class and was equivalent to the rank of army captain; general adjutant to general field marshal was assigned to the VII class and was equivalent to the rank of lieutenant colonel; general adjutant was assigned to the VI class and was equivalent to army colonel. Because of the prestige associated with these positions, Empress Catherine declared that general adjutants were only appointed to the sovereign and matched the rank of army lieutenant general. Emperor Paul regulated appointments to these positions. Under the new system, officers of classes VIII to VI (major, lieutenant colonel, and colonel) were eligible to become "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flügel")]), _vm._v(" adjutant, while officers of classes III to I (lieutenant general, general, and general field marshal) were eligible to become general adjutant. If a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flügel")]), _vm._v(" adjutant was promoted to lieutenant general, he surrendered his position as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flügel")]), _vm._v(" adjutant.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6c43718","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof43.vue
// module id = 222
// module chunks = 0